import Swiper from "swiper/bundle";
// import "./_slider-card.scss";

document.addEventListener("DOMContentLoaded", () => {
  const SliderCards = document.querySelectorAll(".slider-cards");
  SliderCards.forEach((slider) => {
    new Swiper(slider, {
      loop: false,
      spaceBetween: 15,
      slidesPerView: 1.2,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: false,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  });
});
